import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */
import * as Actions from '../../redux/actions';


class UpdateUserAddress extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'Update User Address';
        this.Config   = new AppConfig();
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.updateUserAddress, payload);
    }

    //Parse successful response
    onSuccess() {
        this.updateState();
    }

    //Dispatch actions to update redux state
    updateState() {
        this.dispatch(Actions.getUserData());
    }
}

export default UpdateUserAddress;